<h2 class="mat-h2">My broadcasts</h2>

<mat-card class="card" *ngIf="noChannel">
  <mat-card-content>
    Your account is not linked to a production yet. Ask an administrator to set it up.
  </mat-card-content>
</mat-card>

<mat-card class="card" *ngIf="!noChannel">
  <mat-card-content class="summary">
    <div>
      <div class="big" [ngClass]="waiting ? 'warn' : ''">{{ waiting }}</div>
      <div class="muted">waiting for you</div>
    </div>
    <div>
      <div class="big">{{ approvedTotal | number }} {{ currency }}</div>
      <div class="muted">approved so far</div>
    </div>
    <!-- The same workbook the association downloads, from the same code: an
         argument about an invoice is not settled by two sides holding
         documents that might differ. Approved broadcasts only — what is still
         with you is in the table below, and its amount can still move. -->
    <div class="export">
      <button mat-stroked-button
              [disabled]="!approved || exporting"
              matTooltip="Every approved broadcast of this season — criteria, who decided what and why, the payment lines and the whole discussion"
              (click)="exportSeason()">
        <mat-icon>{{ exporting ? 'hourglass_top' : 'download' }}</mat-icon>
        {{ exporting ? 'Building…' : 'Download season (Excel)' }}
      </button>
      <div class="muted" *ngIf="!approved">nothing approved to download yet</div>
      <div class="muted" *ngIf="approved">{{ approved }} approved broadcast{{ approved === 1 ? '' : 's' }}</div>
      <div class="export-error" *ngIf="exportError">{{ exportError }}</div>
    </div>
  </mat-card-content>
</mat-card>

<table class="games" *ngIf="rows.length">
  <thead>
    <tr>
      <th>Date</th>
      <th>Broadcast</th>
      <th>State</th>
      <th>Payment</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows" [ngClass]="row.waiting ? 'waiting' : ''">
      <td>{{ row.game.date }}</td>
      <td>
        <a [routerLink]="['/evaluation/game', row.game.videoId]">{{ row.game.name }}</a>
        <span class="chip ct" *ngIf="row.game.ctSportPlus"
              matTooltip="Also on ČT Sport+ — the commentary is paid by the association and ČT">ČT Sport+</span>
      </td>
      <td><span class="chip state-{{ row.game.state }}">{{ stateLabels[row.game.state] }}</span></td>
      <td class="amount">{{ row.total | number }} {{ currency }}</td>
      <td>
        <a mat-stroked-button [routerLink]="['/evaluation/game', row.game.videoId]">
          {{ row.waiting ? 'Review' : 'Open' }}
        </a>
      </td>
    </tr>
  </tbody>
</table>

<p class="muted" *ngIf="!rows.length && !noChannel">Nothing has been released to you yet.</p>
